import { HOME } from "../constants";
import { normalizeReviewStatus } from "../utils/deaRole";

export const normalizeReviewFilter = (filter) => {
  const nextFilter = { ...filter };
  nextFilter.reviewStatus = normalizeReviewStatus(nextFilter.reviewStatus);
  return nextFilter;
};

const initialState = {
  totalAssetStats: {
    denchu: "-",
    hh: "-",
    mh: "-",
  },
  homeImageData: [],
  totalImageCount: "--",
  currentPageNumber: 1,
  filteredTotal: "--",
  saitamaCsvSelection: [],
  saitamaCsvExport: {
    loading: false,
    data: [],
    error: null,
  },
  filter: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    signNumber: null,
    assetType: "all",
    manageGroup: {
      key: "all",
      value: [],
    },
    reviewStatus: "APPROVED",
    managementId: "",
    inspectionItems: [],
    firstCaptureOnly: false,
  },
  homeImageDataNtt: [],
  filterNtt: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    assetType: "all",
    prefecturalArea: "all",
    exchangeOfficeName: "all",
    assetInfo: "all",
    photographyTarget: "all",
    photoType: "all",
    twoStepVerification: "all",
    resultTag: "all",
    reviewStatus: "APPROVED",
  },
  homeImageDataHokuden: [],
  filterHokuden: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    assetType: "all",
    powerAssetNumber: null,
    // areaName: "all",
    username: "all",
    municipality: "all",
    branchName: "all",
    resultTag: "all",
    reviewStatus: "APPROVED",
  },
  hokudenOptionCity: [],
  hokudenOptionBranch: [],
  homeMissionImageData: [],
};

export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case HOME.SET_TOTAL_STATS_DATA:
      return {
        ...state,
        totalAssetStats: action.payload,
      };
    case HOME.SET_HOME_IMAGE_DATA:
      return {
        ...state,
        homeImageData: action.payload,
      };
    case HOME.SET_TOTAL_IMAGE_COUNT:
      return {
        ...state,
        totalImageCount: action.payload,
      };
    case HOME.SET_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case HOME.SET_FILTERED_TOTAL:
      return {
        ...state,
        filteredTotal: action.payload,
      };
    case HOME.SET_FILTER:
      return {
        ...state,
        filter: normalizeReviewFilter(action.payload),
      };
    case HOME.SET_SAITAMA_CSV_SELECTION:
      return {
        ...state,
        saitamaCsvSelection: action.payload,
      };
    case HOME.REQUEST_SAITAMA_CSV_EXPORT:
      return {
        ...state,
        saitamaCsvExport: {
          loading: true,
          data: [],
          error: null,
        },
      };
    case HOME.SET_SAITAMA_CSV_EXPORT_LOADING:
      return {
        ...state,
        saitamaCsvExport: {
          ...state.saitamaCsvExport,
          loading: action.payload,
        },
      };
    case HOME.SET_SAITAMA_CSV_EXPORT_DATA:
      return {
        ...state,
        saitamaCsvExport: {
          loading: false,
          data: action.payload || [],
          error: null,
        },
      };
    case HOME.SET_SAITAMA_CSV_EXPORT_ERROR:
      return {
        ...state,
        saitamaCsvExport: {
          loading: false,
          data: [],
          error: action.payload || "CSV出力に失敗しました",
        },
      };
    case HOME.CLEAR_SAITAMA_CSV_EXPORT:
      return {
        ...state,
        saitamaCsvExport: {
          loading: false,
          data: [],
          error: null,
        },
      };
    case HOME.SET_HOME_IMAGE_DATA_NTT:
      return {
        ...state,
        homeImageDataNtt: action.payload,
      };
    case HOME.SET_FILTER_NTT:
      return {
        ...state,
        filterNtt: normalizeReviewFilter(action.payload),
      };
    case HOME.SET_HOME_IMAGE_DATA_HOKUDEN:
    return {
      ...state,
      homeImageDataHokuden: action.payload,
    };
    case HOME.SET_FILTER_HOKUDEN:
      return {
        ...state,
        filterHokuden: normalizeReviewFilter(action.payload),
      };
    case HOME.SET_HOKUDEN_OPTION_CITY:
      return {
        ...state,
        hokudenOptionCity: action.payload,
      };
    case HOME.SET_HOKUDEN_OPTION_BRANCH:
      return {
        ...state,
        hokudenOptionBranch: action.payload,
      };
    case HOME.SET_HOME_MISSION_IMAGE_DATA:
      return {
        ...state,
        homeMissionImageData: action.payload,
      };
      default:
        return state;
    }
}
